import React, { ReactNode, useEffect, useState } from "react"
import { CollapsablePanel } from "../../collapsable-panel"
import { Flex, Stack, Text } from "../../../vanilla"
import { CheckIcon } from "../../icons"
import { FieldOptions } from "../../../types/forms"

interface RadioTitleProps {
    currentValue: string | undefined
    setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
    setCurrentValue: React.Dispatch<React.SetStateAction<string | undefined>>
    option: FieldOptions
    name: string
}

const RadioTitle = ({ currentValue, setIsOpen, setCurrentValue, option, name }: RadioTitleProps) => {
    const { id, label } = option

    useEffect(() => {
        setIsOpen(id === currentValue)
    }, [currentValue])

    return (
        <Flex
            as='label'
            align="center"
            border="1px"
            borderColor={id === currentValue ? 'accent1' : 'gray200'}
            borderRadius="base"
            paddingY="8px"
            paddingX="12px"
            gap="8px"
            cursor="pointer"
        >
            <input hidden type='radio' name={name} onChange={() => { setCurrentValue(id) }} />
            <Flex
                align="center"
                justify="center"
                border="1px"
                borderColor={id === currentValue ? 'accent1' : 'gray200'}
                borderRadius="full"
                boxSize="20px"
                bg={id === currentValue ? 'accent1' : 'white'}
            >
                {id === currentValue && <CheckIcon style={{ height: 12, width: 12 }} color="white" />}
            </Flex>
            <Text variant="text4">{label}</Text>
        </Flex>
    )
}


interface RadioGroupProps {
    name: string
    options: FieldOptions[]
    defaultValue: string | undefined
    onChange: (...event: any[]) => void
}
export const RadioGroup = ({ name, options, defaultValue, onChange }: RadioGroupProps) => {
    const [currentValue, setCurrentValue] = useState<string | undefined>(defaultValue)

    useEffect(() => {
        // Update the form data to the selected value when the radio is changed
        onChange(currentValue)
    }, [currentValue])

    return (
        <Stack>
            {options.map((option) => (
                <CollapsablePanel defaultOpen={option.id === currentValue} panelContent={option.content ?? <></>}>
                    {({ setIsOpen }) => <RadioTitle currentValue={currentValue} setIsOpen={setIsOpen} setCurrentValue={setCurrentValue} option={option} name={`${name}1`} />}
                </CollapsablePanel>
            ))}
        </Stack>
    )
}